export default {
  title: '空运运价',
  createTitle: '新建空运运价',
  editTitle: '编辑空运运价',
  viewTitle: '空运运价详情',
  copyTitle: '复制空运运价',
  filters: {
    priceNo: '运价编号',
    source: '运价来源',
    airline: '航空公司',
    pol: '起运机场',
    pod: '目的机场',
    status: '运价状态',
    specialPriceStatus: '特价状态',
    validity: '有效期',
    originCountry: '起运国',
    destinationCountry: '目的国',
    originCity: '起运城市',
    destinationCity: '目的城市',
    supplier: '供应商',
    office: '所属公司',
    cargoType: '货物类型',
    directFlag: '直达/中转',
    transferPort: '中转机场',
    lane: '航线分类',
    validPeriod: '有效期'
  },
  placeholders: {
    priceNo: '请输入运价编号',
    source: '请选择运价来源',
    company: '请选择分公司',
    supplier: '请选择供应商',
    cargoType: '请选择货物类型',
    airline: '请选择航空公司',
    pol: '请选择起运机场',
    pod: '请选择目的机场',
    validPeriod: '请选择有效期',
    status: '请选择运价状态',
    validity: '请选择有效期',
    remark: '如预约要求、截货时间等',
    transferPort: '请选择中转机场',
    originCountry: '请选择起运国',
    destinationCountry: '请选择目的国',
    originCity: '请选择起运城市',
    destinationCity: '请选择目的城市',
    directFlag: '请选择直达/中转',
    lane: '请选择航线分类',
    eta: '请选择预计到港日',
    etd: '请选择预计开航日',
    voyageHours: '请输入航程小时数（整数）',
    serviceType: '请选择服务类型',
    onePrice: '请选择是否一口价',
    receivingInstructions: '请输入接货特殊说明',
    flightDepartureTime: '请选择起飞时间',
    flightArrivalTime: '请选择到达时间',
    selectDepartureWeekdays: '请选择开航班期'
  },
  validation: {
    voyageHoursInteger: '航程仅支持非负整数，不可输入小数'
  },
  columns: {
    priceNo: '运价编号',
    source: '运价来源',
    airline: '航空公司',
    supplier: '供应商',
    pol: '起运机场',
    pod: '目的机场',
    nPrice: 'N价(<45KG)',
    normal: 'N价(<45KG)',
    p45: '+45KG',
    p100: '+100KG',
    p300: '+300KG',
    p500: '+500KG',
    p1000: '+1000KG',
    p2000: '+2000KG',
    validPeriod: '有效期',
    validity: '有效期',
    status: '运价状态',
    specialPriceStatus: '特价状态',
    actions: '操作',
    feeName: '费用名称',
    type: '费用类型',
    price: '单价',
    unit: '单位',
    remark: '备注',
    minCharge: '最低收费',
    maxCharge: '最高收费',
    feeSource: '费用来源'
  },
  fields: {
    priceNo: '运价编号',
    source: '运价来源',
    relationNo: '关联单号',
    company: '分公司',
    supplier: '供应商',
    cargoType: '货物类型',
    contractNo: '约号',
    validPeriod: '有效期',
    airline: '航空公司',
    flightNo: '航班号',
    pol: '起运机场',
    pod: '目的机场',
    pickupAddr: '提货地',
    routeLevel: '航线等级',
    spaceStatus: '舱位状态',
    packageType: '包装类型',
    directFlag: '直航/中转',
    transitTime: '航程(小时)',
    currency: '币种',
    volWeightRatio: '体积重转换系数',
    payTerm: '付费条款',
    densityLevel: '密度等级',
    remark: '备注',
    specialCargoRemark: '特殊货物说明',
    transportTerm: '运输方式',
    tradeTerm: '贸易条款',
    specialPriceStatus: '特价状态',
    transferPort: '转运机场',
    etd: 'ETD',
    eta: 'ETA',
    beginDate: '生效日期',
    endDate: '失效日期',
    viewRule: '查看规则',
    systemRule: '系统规则',
    userCreated: '用户创建',
    serviceType: '服务类型',
    onePrice: '一口价',
    receivingInstructions: '接货特殊说明',
    flightDepartureTime: '起飞时间',
    flightArrivalTime: '到达时间',
    departureWeekdays: '开航班期',
    costPrice: '成本'
  },
  enums: {
    source: {
      '1': '手工录入',
      '2': 'Excel导入',
      '3': '询价入库',
      '4': '招标入库'
    },
    status: {
      1: '待上架',
      2: '正常',
      3: '失效',
      4: '下架',
      5: '禁用',
      6: '待导入'
    },
    specialPriceStatus: {
      '1': '不允许申请特价',
      '2': '允许申请特价',
      '3': '特价'
    },
    cargoTypes: {
      '1': '普货',
      '2': '危险品',
      '3': '冷冻品',
      '4': '特种箱',
      '5': '卷钢',
      '6': '液体',
      '7': '化工品',
      '8': '纺织品'
    },
    routeLevels: {
      '1': '极速',
      '2': '标准',
      '3': '经济'
    },
    packageTypes: {
      '1': '纸箱',
      '2': '木箱',
      '3': '托盘',
      '4': '散货'
    },
    rateTypes: {
      '1': '一级代理',
      '2': '二级代理',
      '3': '电商价格'
    },
    offices: {
      '1': '上海',
      '2': '深圳',
      '3': '广州'
    },
    directFlags: {
      direct: '直航',
      transit: '转运'
    },
    payTerms: {
      prepaid: '预付',
      collect: '到付'
    },
    surchargeTypes: {
      AIR: '干线附加费',
      POR: '起飞地费用',
      FND: '目的地费用'
    },
    units: {
      KG: 'KG',
      ticket: '票'
    },
    surchargeNames: {
      fsc: '燃油附加费',
      ssc: '安检费',
      awb: '运单费',
      myc: '燃油战争险',
      doc: '文件费',
      hdl: '操作费'
    },
    serviceTypes: {
      CONSOL: '散货',
      FULL_PALLET: '整板',
      BLOCK_SPACE: '整舱',
      FULL_CHARTER: '包机'
    }
  },
  sections: {
    basicInfo: '基础信息',
    flightInfo: '航班信息',
    feeDetail: '费用明细',
    freight: '运费',
    surcharge: '附加费明细',
    remark: '备注信息',
    serviceAndOther: '物流参数与备注'
  },
  actions: {
    back: '返回',
    edit: '编辑',
    copy: '复制',
    saveDraft: '保存草稿',
    publish: '上架',
    add: '新增空运运价',
    import: '导入',
    export: '导出',
    downloadTemplate: '下载模板',
    aiRecognition: 'AI识别',
    batchOperations: '批量操作',
    batchPublish: '批量上架',
    batchOffline: '批量下架',
    batchPriceChange: '批量改价',
    batchTimeChange: '批量改时间',
    batchDelete: '批量删除',
    view: '详情',
    more: '更多',
    delete: '删除',
    offline: '下架',
    addSurcharge: '添加附加费',
    addFeeManually: '手动添加费用',
    cancel: '取消',
    confirm: '确定',
    reset: '重置'
  },
  messages: {
    fetchFailed: '获取数据失败',
    saveSuccess: '草稿保存成功',
    publishSuccess: '成功上架 {count} 条运价',
    deleteSuccess: '成功删除 {count} 条运价',
    offlineSuccess: '成功下架 {count} 条运价',
    deleteConfirm: '确定要删除选中的 {count} 条运价吗？此操作不可恢复。',
    systemMatched: '系统规则已匹配',
    importSuccess: '导入成功',
    downloadingTemplate: '正在下载',
    uploading: '正在上传...',
    validating: '正在校验...',
    matching: '匹配规则...',
    saving: '保存数据...',
    generatingErrorReport: '正在生成错误报告...',
    batchPublishSuccess: '已批量上架 {count} 条',
    onlyDraftCanPublish: '只有草稿和待导入状态的运价才能上架，当前包含：{status}',
    onlyNormalCanOffline: '只有已发布状态的运价才能下架，当前包含：{status}',
    onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前包含：{status}',
    offlineConfirm: '确定要将选中的 {count} 条运价下架吗？',
    noSelection: '请至少选择一条记录',
    batchUpdateSuccess: '批量更新成功',
    selectValidity: '请选择有效期',
    onlyDraftCanModify: '只能修改草稿状态',
    recordsToModify: '将被修改的运价列表',
    selectedCount: '已选择 {count} 项',
    comingSoon: '敬请期待',
    exportFilename: '空运运价导出',
    templateDownloadFailed: '模板下载失败'
  },
  batch: {
    timeChange: {
      currentEtd: '当前 ETD',
      currentEta: '当前 ETA',
      currentValidPeriod: '当前有效期'
    }
  },
  aiRecognition: {
    title: 'AI智能识别',
    uploadTitle: '上传运价文件',
    uploadDesc: '点击或拖拽文件到此区域，系统将自动识别内容并提取运价信息',
    processing: 'AI正在识别中...',
    processingDesc: '请稍候，AI正在分析您的运价文件...',
    success: '识别成功！',
    successDesc: '运价信息已成功识别并导入',
    error: '识别失败',
    errorDesc: '文件识别失败，请检查文件格式或重新上传',
    retry: '重新上传',
    aiDescription: 'AI识别说明',
    aiFeatures: [
      'AI将自动识别运价表格中的港口、船公司、价格等信息',
      '支持多种文件格式 and 复杂表格结构',
      '识别完成后会创建后台任务进行处理',
      '请确保上传的文件清晰可读'
    ],
    successTitle: 'AI识别任务已提交',
    successDescription: '当前任务后台正在运行中，请到<strong>系统设置 - 任务管理</strong>中查看任务进度与结果。',
    goToTaskManagement: '前往任务管理',
    close: '关闭',
    uploadFile: '上传{type}文件',
    clickOrDrag: '点击或拖拽文件到此区域上传',
    supportedFormats: '支持格式：PDF、Excel、Word、图片等',
    selectFile: '选择文件',
    aiParsing: 'AI解析中...',
    aiParsingTip: 'AI正在解析文档，请稍候...'
  },
  form: {
    sections: {
      basicInfo: '基础信息',
      routeInfo: '路线信息',
      validityInfo: '时效信息',
      weightPrice: '重量段价格(USD/KG)',
      remark: '备注'
    },
    labels: {
      airline: '航空公司',
      supplier: '供应商',
      cargoType: '货物类型',
      pol: '起运机场',
      pod: '目的机场',
      directFlag: '直航/中转',
      validityDate: '有效期',
      flightNo: '航班号',
      minCharge: 'M(最低消费)',
      nPrice: 'N(<45KG)',
      price45: '+45KG',
      price100: '+100KG',
      price300: '+300KG',
      price500: '+500KG',
      price1000: '+1000KG',
      specialCargoRemark: '特殊货物说明',
      remark: '备注'
    },
    placeholders: {
      airline: '请选择航空公司',
      supplier: '请选择供应商',
      cargoType: '请选择货物类型',
      pol: '请选择起运机场',
      pod: '请选择目的机场',
      flightNo: '请输入航班号',
      minCharge: '最低消费金额',
      nPrice: '45KG以下单价',
      price45: '45KG及以上单价',
      price100: '100KG及以上单价',
      price300: '300KG及以上单价',
      price500: '500KG及以上单价',
      price1000: '1000KG及以上单价',
      specialCargoRemark: '请输入特殊货物说明，如带电、危险品等',
      remark: '请输入其他补充说明'
    },
    options: {
      general: '普货',
      dangerous: '危险品',
      cold: '冷冻货',
      oversize: '大件货',
      direct: '直航',
      transit: '中转'
    },
    validation: {
      airline: '请选择航空公司',
      supplier: '请选择供应商',
      cargoType: '请选择货物类型',
      pol: '请选择起运机场',
      pod: '请选择目的机场',
      validityDate: '请选择有效期',
      nPrice: '请输入N价'
    },
    airlines: {
      CX: '国泰航空(CX)',
      CA: '中国国际航空(CA)',
      MU: '东方航空(MU)',
      CZ: '南方航空(CZ)',
      HU: '海南航空(HU)'
    },
    airports: {
      HKG: '香港机场(HKG)',
      PVG: '上海浦东机场(PVG)',
      PEK: '北京首都机场(PEK)',
      LAX: '洛杉矶机场(LAX)',
      FRA: '法兰克福机场(FRA)',
      NRT: '东京成田机场(NRT)'
    }
  }
}
